import React, { useId, useState } from 'react';
import { SectionLabel } from './SectionLabel';
import { AccordionRow } from './Accordion';
import { includedGroups } from '../data/whatsIncluded';
function IncludedGroupSection({
  label,
  note,
  count,
  children
}: {
  label: string;
  note?: string;
  count: number;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const buttonId = useId();
  return <div className="border-t border-ink/15" data-id="element-115" data-mp="pwpafglkrhvw">
      <button type="button" id={buttonId} aria-expanded={open} aria-controls={panelId} onClick={() => setOpen(prev => !prev)} className="w-full flex items-baseline justify-between gap-6 py-7 text-left transition-opacity duration-150 ease-out hover:opacity-70 focus:outline-none focus-visible:ring-1 focus-visible:ring-brass" data-id="element-116" data-mp="uuig88iyu9vn">
        <span className="flex items-baseline gap-4" data-id="element-117" data-mp="31nb7csyukubo">
          <span className="font-serif font-normal text-xl md:text-2xl leading-snug text-ink" data-id="element-118" data-mp="36l2w5e4740bn">
            {label}
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink/40" data-id="element-119" data-mp="1whxff4qwtcss">
            {count}
          </span>
        </span>
        <span aria-hidden="true" className="font-serif text-brass text-2xl leading-none shrink-0" data-id="element-120" data-mp="26gebuh8majm8">
          {open ? '×' : '+'}
        </span>
      </button>

      <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-[grid-template-rows] duration-200 ease-out ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-121" data-mp="2fgjgwkqc95x8">
        <div className="overflow-hidden" data-id="element-122" data-mp="2p51ih46fzh1x">
          {note && <p className="font-serif italic font-light text-ink/60 text-base pb-4" data-id="element-123" data-mp="2k6q7gq4ev0i4">
              {note}
            </p>}
          <div className="pb-6 pl-0 md:pl-6" data-id="element-124" data-mp="2y7u9r7fmjsrr">{children}</div>
        </div>
      </div>
    </div>;
}
export function WhatsIncluded() {
  return <section className="py-24 md:py-32 px-6 md:px-12 lg:px-24 max-w-5xl mx-auto border-t border-ink/10" data-id="element-125" data-mp="318nnzc7oqj5g">
      <SectionLabel title="What's Included" className="mb-12 md:mb-16" data-id="element-126" data-mp="367h1v5qvwc65" />

      <div className="border-b border-ink/15" data-id="element-127" data-mp="365mhbsjiym2l">
        {includedGroups.map(group => <IncludedGroupSection key={group.label} label={group.label} note={group.note} count={group.items.length} data-id="element-128" data-mp="3b5igneha1pbt">
            {group.items.map(item => <AccordionRow key={item.title} title={item.title} body={item.body} data-id="element-129" data-mp="3k1huriv5n4yl" />)}
          </IncludedGroupSection>)}
      </div>
    </section>;
}